import moment from "moment";

export const formatDate = (dateString, format = "DD/MM/YYYY") => moment(dateString).format(format);

export default function useDates() {
  function formattedDate(dateString, format) {
    return formatDate(dateString, format);
  }

  return {
    formattedDate
  };
}